module.exports = __webpack_public_path__ + "img/RJ.c67cdc15.png";